import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[rt-select-search]',
  exportAs: 'searchDir',
})
export class Select2SearchDirective {
  constructor(public templateRef: TemplateRef<void>) {}
}
